import { useState } from "react";
import "../styles/options.css";

interface GameOptionsMenuProps {
  onResign: () => void;
  onToggleMute: () => void;
  isMuted: boolean;
  disabled?: boolean;
}

export function GameOptionsMenu({
  onResign,
  onToggleMute,
  isMuted,
  disabled
}: GameOptionsMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    if (disabled) return;
    setIsOpen(true);
  };

  const handleResign = () => {
    setIsOpen(false);
    onResign();
  };

  const handleMuteToggle = () => {
    setIsOpen(false);
    onToggleMute();
  };

  return (
    <div className="game-options-controls">
      {/* Options trigger button */}
      <button
        onClick={handleOpen}
        disabled={disabled}
        className="options-trigger-button"
        aria-label="Open game options"
      >
        ⚙️
      </button>

      {/* Options panel */}
      {isOpen && (
        <>
          <div className="options-panel-backdrop" onClick={() => setIsOpen(false)} />
          <div className={`options-side-panel ${isOpen ? "open" : ""}`}>
            <div className="options-list">
              <button onClick={handleResign} className="option-item resign-option">
                🏳️ Resign Game
              </button>
              <button onClick={handleMuteToggle} className="option-item mute-option">
                {isMuted ? "🔊 Unmute Emotes" : "🔇 Mute Emotes"}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
